import { sendGet } from './../helpers/axiosSSo';

export const getInforUser = (params) => sendGet('/api/user/auth', params);
